// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"edeb8d47","72":"79fbb3e2","161":"b299c1a1","194":"b02ef2ef","256":"07d97ad7","360":"8a9a4070","385":"7321c9a3","420":"6cc645e5","579":"c09d03fc","642":"c94c05df","747":"a5993ef9","810":"96e5fcaf","892":"44dd70e7","938":"d1aa3108"}[chunkId] + ".chunk.js";
};